export default {
  name: "Error",
  setup() {},
};
